module.exports = __webpack_public_path__ + "3b52ba1d893d2412688335c620453883.svg";